import { gql } from '@apollo/client';

import { mediaItemFragment } from '../fragments';

export default gql`
  query GetMediaItemById(
    $courseId: String!
    $subjectId: String!
    $mediaItemId: String!
  ) {
    mediaItem(
      courseId: $courseId
      subjectId: $subjectId
      mediaItemId: $mediaItemId
    )
      @rest(
        type: "MediaItem"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/videos/{args.mediaItemId}"
      ) {
      ...MediaItem
    }
  }
  ${mediaItemFragment}
`;
